import { ReviewItem } from '@/types/api';
import IconStarSmall from '@/assets/icons/OrderDetails/IconStarSmall.svg?react';
import { Separator } from '@/components/atoms/Seperator';

const ReviewProfile = ({ review }: { review: ReviewItem }) => {
  const isAnswered = review.ReviewCommentList && review.ReviewCommentList.length > 0;
  const isUnanswerable = !review.IsMarketCommentEnable;

  // 평점이 있으면 별점 표시
  const hasScore = review.ReviewScore > 0;

  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-[12px] gap-y-[6px] text-gr-800">
      <MarketName review={review} />
      {hasScore && <ReviewScore review={review} />}
      <div className="flex shrink-0 items-center gap-[12px]">
        <Separator orientation="vertical" className="h-[18px] w-[1px] bg-gr-200" />
        <ReviewDate review={review} />
      </div>
      {/* 상태 뱃지 */}
      {!isUnanswerable && (
        <span className="shrink-0">{isAnswered ? <AnsweredBadge /> : <UnansweredBadge />}</span>
      )}
    </div>
  );
};

export default ReviewProfile;

export const MarketName = ({ review }: { review: ReviewItem }) => {
  return (
    <div className="flex flex-shrink-0 items-center gap-1">
      <img src={review.MarketIconUrl} alt="" className="h-5 w-5" />
      <span className="text-gr-800 Body5M14">{review.StoreName}</span>
    </div>
  );
};

const ReviewScore = ({ review }: { review: ReviewItem }) => {
  return (
    <div className="flex items-center gap-[12px]">
      <Separator orientation="vertical" className="h-[18px] w-[1px]  bg-gr-200" />
      <span className="flex items-center gap-[6px]">
        <IconStarSmall />
        <span className="text-gr-800 Body5M14">{review.ReviewScore.toFixed(1)}</span>
      </span>
    </div>
  );
};

const ReviewDate = ({ review }: { review: ReviewItem }) => {
  const dateObj = new Date(review.ReviewDate);
  const yy = String(dateObj.getFullYear()).slice(2, 4);
  const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
  const dd = String(dateObj.getDate()).padStart(2, '0');
  const hh = String(dateObj.getHours()).padStart(2, '0');
  const min = String(dateObj.getMinutes()).padStart(2, '0');

  return <span className="whitespace-nowrap Body5M14">{`${yy}/${mm}/${dd} ${hh}:${min}`}</span>;
};

const AnsweredBadge = () => (
  <span className="whitespace-nowrap rounded-[8px] bg-gr-100 px-2 py-1 text-xs text-gr-600">
    답변완료
  </span>
);

const UnansweredBadge = () => (
  <span className="whitespace-nowrap rounded-[8px] bg-point-100 px-[6px] py-[2px] text-point-500 Caption1M12">
    바로등록 가능
  </span>
);
